"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("span", [_c("span", {
    on: {
      click: function ($event) {
        _vm.visible = true;
      }
    }
  }, [_vm._t("default", function () {
    return [_c("a-button", {
      attrs: {
        type: "link",
        size: "small"
      }
    }, [_vm._v("+添加人员")])];
  }), _vm.desc ? _c("span", {
    staticClass: "m-tips-color"
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()], 2), _c("BasisModal", {
    attrs: {
      width: 1020
    },
    on: {
      ok: _vm.handleOk
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c("div", {
          staticClass: "m-flex"
        }, [_vm._v(" " + _vm._s(_vm.title) + " "), _c("div", {
          staticClass: "m-m-l-16 m-tips-color m-fw-normal"
        }, [_vm._v(" 已选择("), _c("span", {
          staticClass: "m-type-primary"
        }, [_vm._v(_vm._s(_vm.selectedUserIds && _vm.selectedUserIds.length))]), _vm._v(")人 "), _c("a-tooltip", {
          attrs: {
            placement: "rightTop",
            title: _vm.selectedUser
          }
        }, [_vm.selectedUser ? _c("a", {
          staticClass: "m-type-primary"
        }, [_vm._v("明细")]) : _vm._e()])], 1)])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-layout", {
    staticStyle: {
      height: "calc(70vh - 64px)"
    }
  }, [_c("a-layout-sider", [_c("a-input-search", {
    attrs: {
      "allow-clear": "",
      placeholder: "输入部门名称搜索"
    },
    on: {
      change: _vm.debouncedSearch
    },
    model: {
      value: _vm.keyword,
      callback: function ($$v) {
        _vm.keyword = typeof $$v === "string" ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  }), _c("div", {
    staticClass: "tree-box"
  }, [_c("a-tree", {
    attrs: {
      "replace-fields": _vm.replaceFields,
      "expanded-keys": _vm.expandedKeys,
      "auto-expand-parent": _vm.autoExpandParent,
      "tree-data": _vm.treeData
    },
    on: {
      select: _vm.handleSelectTree,
      expand: _vm.onExpand
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function (data) {
        return [data[_vm.replaceFields.title].indexOf(_vm.keyword) > -1 ? _c("span", {
          staticClass: "m-flex",
          attrs: {
            title: data[_vm.replaceFields.title]
          }
        }, [_vm._v(" " + _vm._s(data[_vm.replaceFields.title].substr(0, data[_vm.replaceFields.title].indexOf(_vm.keyword))) + " "), _c("span", {
          staticStyle: {
            "background-color": "#ff9632"
          }
        }, [_vm._v(_vm._s(_vm.keyword))]), _vm._v(" " + _vm._s(data[_vm.replaceFields.title].substr(data[_vm.replaceFields.title].indexOf(_vm.keyword) + _vm.keyword.length)) + " ")]) : _c("span", {
          attrs: {
            title: data[_vm.replaceFields.title]
          }
        }, [_vm._v(_vm._s(data[_vm.replaceFields.title]))])];
      }
    }])
  })], 1)], 1), _c("a-layout-content", {
    staticClass: "m-m-l-16",
    staticStyle: {
      "margin-top": "-4px"
    }
  }, [_c("BasisTableLayout", {
    ref: "basisTableLayout",
    attrs: {
      "row-key": "userId",
      "default-selected-row-keys": _vm.defaultSelectedUserIds,
      "default-selected-rows": _vm.defaultSelectedUsers,
      selectable: true,
      scroll: {
        y: "calc(70vh - 190px)"
      },
      method: _vm.getUserListMethod,
      params: {
        deptId: _vm.deptId
      },
      columns: _vm.columns,
      "transform-data-source": _vm.transformDataSource,
      "search-form-props": {
        limit: 3
      }
    },
    on: {
      rowSelectionChange: _vm.handleRowSelectionChange
    },
    scopedSlots: _vm._u([{
      key: "userName",
      fn: function ({
        record
      }) {
        return [_c("a-popover", {
          attrs: {
            title: record.userName,
            placement: "right",
            trigger: "hover"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function () {
              return [_c("div", {
                staticClass: "m-flex m-row-center"
              }, [_c("a-avatar", {
                staticStyle: {
                  "flex-shrink": "0",
                  "background-color": "#2483ff"
                },
                attrs: {
                  shape: "square",
                  size: 150,
                  src: record.avatar
                }
              }, [_vm._v(_vm._s(record.userName.slice(-2)))])], 1)];
            },
            proxy: true
          }], null, true)
        }, [_c("div", {
          staticClass: "m-flex"
        }, [_c("a-avatar", {
          staticStyle: {
            "flex-shrink": "0",
            "background-color": "#2483ff"
          },
          attrs: {
            shape: "square",
            size: "small",
            src: record.avatar
          }
        }, [_vm._v(_vm._s(record.userName.slice(-2)))]), _c("span", {
          staticClass: "m-m-l-4 m-line-1",
          attrs: {
            title: record.userName
          }
        }, [_vm._v(_vm._s(record.userName))])], 1)])];
      }
    }, {
      key: "mobile",
      fn: function ({
        record
      }) {
        return [_c("span", {
          attrs: {
            title: record.mobile + "_点击可复制"
          },
          on: {
            click: function ($event) {
              return _vm.handleCopy(record.mobile);
            }
          }
        }, [_vm._v(_vm._s(_vm.$m.dataDesensitization(record.mobile)))])];
      }
    }])
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;